import { useScrollAnimation } from '@/hooks/useScrollAnimation';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@/components/ui/accordion';

const faqs = [
  {
    q: 'Sou MEI, preciso mesmo de um contador?',
    a: 'Pela lei, o MEI não é obrigado a ter contador. Mas na prática, muito MEI perde dinheiro por não saber que pode deduzir certas coisas, emite nota errada, ultrapassa o limite de faturamento sem perceber ou deixa de entregar a declaração anual e toma multa. Ter um contador pelo valor do nosso plano (R$ 49,90/mês) sai mais barato do que uma única multa e te dá tranquilidade pra focar no negócio.',
  },
  {
    q: 'Estou no Simples Nacional, tem como pagar menos imposto?',
    a: 'Tem, sim — dentro da lei. A maior parte das empresas do Simples está no anexo errado ou não aproveita benefícios do Fator R (para prestadores de serviço), por exemplo. A FinContex faz revisão trimestral pra garantir que você está no melhor anexo e pagando o menor imposto possível dentro do que a legislação permite.',
  },
  {
    q: 'Escolher o CNAE correto faz reduzir imposto?',
    a: 'Faz uma diferença enorme. O CNAE define seu anexo no Simples Nacional, que por sua vez define sua alíquota. Uma empresa classificada no CNAE errado pode pagar até o dobro de imposto. Na abertura de empresa (grátis no plano anual), a gente analisa sua atividade real e escolhe os CNAEs que te colocam na melhor alíquota possível.',
  },
  {
    q: 'A Reforma Tributária vai atingir empresas do Simples Nacional?',
    a: 'Por enquanto, quem está no Simples Nacional continua recolhendo tudo pelo DAS normalmente — o impacto direto é limitado nos primeiros anos. Mas existe uma opção chamada "regime híbrido" (decisão até setembro de 2026) em que a empresa pode recolher CBS e IBS por fora do DAS, o que pode ser vantajoso em alguns casos (principalmente para quem vende para outras empresas). A FinContex acompanha essas regras e te avisa antes do prazo se vale a pena migrar ou continuar no Simples tradicional.',
  },
  {
    q: 'Quanto custa a contabilidade para MEI?',
    a: 'O Plano MEI da FinContex custa R$ 49,90/mês e inclui o DAS mensal, a declaração anual (DASN-SIMEI), orientação para emissão de notas fiscais e alerta quando você se aproximar do limite de R$ 81 mil/ano de faturamento.',
  },
  {
    q: 'E para empresa no Simples Nacional, quanto custa?',
    a: 'Temos dois planos: Simples Serviços por R$ 147/mês (prestadores de serviço) e Simples Comércio por R$ 197/mês (comércio e indústria). Ambos incluem contabilidade completa, apuração do Simples, declarações acessórias e departamento pessoal para até 2 integrantes.',
  },
  {
    q: 'Preciso ir presencialmente ao escritório?',
    a: 'Não. A FinContex é 100% online. Você manda documentos pelo WhatsApp ou e-mail e se comunica com nossa equipe pelos canais digitais. Atendemos clientes em todo o Brasil.',
  },
  {
    q: 'Como funciona a abertura de empresa?',
    a: 'Cuidamos do processo inteiro: escolha de CNAE, viabilidade, contrato social, registro na Junta Comercial, emissão do CNPJ, inscrições estadual e municipal quando aplicáveis. Em média, sua empresa fica pronta em 5 a 10 dias úteis. Ao contratar um plano anual (12 meses), os nossos honorários de abertura são gratuitos — você paga apenas as taxas oficiais (Junta, alvará, certificado digital).',
  },
  {
    q: 'E se eu já tenho contador? Como é a migração?',
    a: 'Tranquila. A gente se comunica com seu contador atual para receber os documentos e históricos, organiza tudo e te coloca na nossa rotina. Você só precisa assinar a autorização e avisar o contador antigo. Não cobramos nada pela transferência.',
  },
  {
    q: 'Tenho CLT na minha empresa. Está incluso?',
    a: 'Os planos Simples Serviços e Simples Comércio já incluem folha completa para até 2 integrantes (sócios ou 1 sócio + 1 CLT). A partir do 3º integrante, cobramos apenas R$ 19,90/mês por funcionário CLT adicional — sem taxa de admissão ou rescisão.',
  },
];

export default function FAQ() {
  const sectionRef = useScrollAnimation();

  return (
    <section
      id="faq"
      data-testid="faq-section"
      ref={sectionRef}
      className="py-24 md:py-32 bg-white"
    >
      <div className="max-w-3xl mx-auto px-6 md:px-12 lg:px-24">
        {/* Header */}
        <div className="scroll-fade text-center mb-16 md:mb-20">
          <p className="text-sm uppercase tracking-[0.2em] font-semibold text-[#10B981] mb-4">
            Dúvidas Frequentes
          </p>
          <h2
            className="text-2xl sm:text-3xl lg:text-4xl font-bold text-[#0A2540] tracking-tight leading-tight"
            style={{ fontFamily: "'Inter', sans-serif", letterSpacing: '-1px' }}
          >
            Perguntas Frequentes
          </h2>
        </div>

        {/* Accordion */}
        <div className="scroll-fade">
          <Accordion type="single" collapsible className="w-full">
            {faqs.map((faq, idx) => (
              <AccordionItem
                key={idx}
                value={`faq-${idx}`}
                data-testid={`faq-item-${idx}`}
                className="border-b border-slate-200"
              >
                <AccordionTrigger
                  data-testid={`faq-trigger-${idx}`}
                  className="text-left text-base md:text-lg font-semibold text-[#0A2540] hover:text-[#10B981] hover:no-underline py-6"
                >
                  {faq.q}
                </AccordionTrigger>
                <AccordionContent className="text-slate-600 text-base leading-relaxed pb-6">
                  {faq.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
}
